const originRedirect = () => {
    
    if(!window.location.origin) {
        window.location.origin = `${window.location.protocol}//${window.location.hostname}${(window.location.port ? `:${window.location.port}` : '')}`;
    }
    window.location.href = window.location.origin;
};

export default originRedirect;
